<!-- 远程会诊 -->
<template>
  <div id="long-range">
    <vice-title>
      <h3>{{ this.$t("lang.BetterMedicalCare.longDistance") }}</h3>
    </vice-title>
    <div id="procedure">
      <el-row :gutter="20">
        <el-col :span="6" class="ele-item"
          ><div class="procedure-item">
            <div class="item-icon iconfont">&#xe62c;</div>
            <div :class="language">
              {{ this.$t("lang.BetterMedicalCare.pathologicalConsultation") }}
            </div>
            <p class="iconfont arrow">&#xe61e;</p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="procedure-item">
            <div class="item-icon iconfont">&#xe61f;</div>
            <div :class="language">
              {{ this.$t("lang.BetterMedicalCare.imagingConsultation") }}
            </div>
            <p class="iconfont arrow">&#xe61e;</p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="procedure-item">
            <div class="item-icon iconfont">&#xe66e;</div>
            <div :class="language">
              {{ this.$t("lang.BetterMedicalCare.expertRecommendation") }}
            </div>
            <p class="iconfont arrow">&#xe61e;</p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="procedure-item">
            <div class="item-icon iconfont">&#xe632;</div>
            <div :class="language">
              {{ this.$t("lang.BetterMedicalCare.materialCollection") }}
            </div>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="procedure-item">
            <div class="item-icon iconfont">&#xe604;</div>
            <div :class="language">
              {{ this.$t("lang.BetterMedicalCare.appointmentConfirmation") }}
            </div>
            <p class="iconfont arrow">&#xe61e;</p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="procedure-item">
            <div class="item-icon iconfont">&#xe6a8;</div>
            <div :class="language">
              {{ this.$t("lang.BetterMedicalCare.longMedical") }}
            </div>
            <p class="iconfont arrow">&#xe61e;</p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="procedure-item">
            <div class="item-icon iconfont">&#xe633;</div>
            <div :class="language">
              {{ this.$t("lang.BetterMedicalCare.outpatientReport") }}
            </div>
            <p class="iconfont arrow">&#xe61e;</p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="procedure-item">
            <div class="item-icon iconfont">&#xe63a;</div>
            <div :class="language">
              {{ this.$t("lang.BetterMedicalCare.followUpService") }}
            </div>
          </div></el-col
        >
      </el-row>
    </div>
    <div id="introduce">
      <div class="introduce-image">
        <div>
          <img
            src="../../assets/images/bestMedicalCare/introduce-left.png"
            alt=""
          />
        </div>
        <div>
          <img
            src="../../assets/images/bestMedicalCare/introduce-right.png"
            alt=""
          />
        </div>
      </div>
      <h3 class="introduce-title">
        {{ this.$t("lang.BetterMedicalCare.serviceIntroduction") }}
      </h3>
      <p class="introduce-content">
        {{ this.$t("lang.BetterMedicalCare.introduceContent") }}
      </p>
      <p class="zhu">
        {{ this.$t("lang.BetterMedicalCare.introduceContentFirst") }}
      </p>
      <p class="zhu">
        {{ this.$t("lang.BetterMedicalCare.introduceContentSecond") }}
      </p>
    </div>
  </div>
</template>

<script>
import ViceTitle from "../ViceTitle";
export default {
  name: "LongRange",
  components: {
    ViceTitle
  },
  data() {
    return {
      language: ""
    };
  },
  mounted() {
    this.setStyle();
  },
  beforeUpdate() {
    this.setStyle();
  },
  methods: {
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.language = "item-title-en";
      } else if (this.$i18n.locale === "zh-CN") {
        this.language = "item-title";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#long-range {
  width: 75%;
  margin: 0 auto;
  overflow: hidden;
  #procedure {
    width: 75%;
    margin: 70px auto;
    .procedure-item {
      width: 94px;
      margin: 0 auto;
      height: 165px;
      position: relative;
      .item-icon {
        height: 94px;
        width: 100%;
        background: $publicBlue;
        border-radius: 50%;
        text-align: center;
        line-height: 94px;
        color: #ffffff;
        font-size: 50px;
      }
      .item-title {
        font-size: 20px;
        text-align: center;
        color: #363636;
        margin-top: 22px;
      }
      .item-title-en {
        font-size: 14px;
        text-align: center;
        color: #363636;
        margin-top: 22px;
      }
    }
  }
  #introduce {
    margin-top: 30px;
    margin-bottom: 30px;
    width: 100%;
    .introduce-image {
      display: flex;
      /*margin: 0 30px;*/
      div {
        flex: 1;
        width: 100%;
        height: 420px;
        &:nth-child(1) {
          margin-right: 40px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .introduce-title {
      margin: 62px 0 34px 0;
      text-align: center;
      font-size: 20px;
      color: $publicBlue;
    }
    .introduce-content {
      margin: 30px 0;
      font-size: 16px;
      color: #7a7a7a;
      line-height: 36px;
      text-indent: 2em;
    }
    .zhu {
      width: 100%;
      /*margin: 0 auto;*/
      /*text-align: center;*/
      font-size: 14px;
      line-height: 32px;
      color: #9e9e9e;
    }
  }
}
.arrow {
  position: absolute;
  top: 20%;
  right: -70%;
  font-size: 26px;
  color: $publicBlue;
}
</style>
